<p>buyer-account-resetpwd works!</p>
